import React from "react";
import { FlameIcon } from "lucide-react";
export function ScarcityBar() {
  return <div className="w-full" data-id="element-184" data-mp="2ywugom0tvwcc">
      <div className="mb-2 flex items-center justify-center gap-1.5 text-sm font-bold text-[#8a3a52]" data-id="element-185" data-mp="2yv1994ie583a">
        <FlameIcon className="h-4 w-4 fill-[#a04a63] text-[#a04a63]" data-id="element-186" data-mp="2l44uohlaurf8" />
        ¡Solo quedan <span className="font-serif-display text-base" data-id="element-187" data-mp="2q2zbjdzpi5wp">7 cupos</span> al precio promocional!
      </div>
      <div className="h-4 w-full overflow-hidden rounded-full bg-[#e7d3d8] shadow-inner" data-id="element-188" data-mp="2b5ozo3j5iy0g">
        <div className="h-full rounded-full bg-gradient-to-r from-[#c98aa0] to-[#a04a63]" style={{
        width: "93%"
      }} data-id="element-189" data-mp="2g638vowhoe02" />
      </div>
      <p className="mt-1.5 text-center text-xs font-semibold text-[#9a7d84]" data-id="element-190" data-mp="228erws5jlr0a">
        93% de los cupos promocionales ya reservados
      </p>
    </div>;
}